/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { toGroupingExpression } from '../toGroupingExpression';
import { toPredicateExpression } from '../toPredicateExpression';
import { FilterGroupingOperation, FilterOperation, FilterCollation } from '../../enums';

import type { FilterExpression, GroupingExpression, PredicateExpression } from '../../interfaces';

export function combineFilters(filters: Record<string, string | number | (string | number)[]>): FilterExpression[] {
    const keys = Object.keys(filters);

    if (!keys.length) {
        return [];
    }

    let restFilters: FilterExpression[] = [];

    if (keys.length === 1) {
        const key = keys[0];
        const values = filters[key];

        restFilters.push(transform(key, values));
    } else {
        restFilters = [{
            operation: FilterGroupingOperation.And,
            items: Object.entries(filters)
                .map(([key, values]) => transform(key, values))
                .filter(x => x),
        }];
    }

    return restFilters.filter((x) => {
        if (x && x.hasOwnProperty('items')) {
            return (x as GroupingExpression).items.length;
        }

        return x;
    });
}

function transform(key: string, values: unknown): GroupingExpression | PredicateExpression {
    if (values === null || values === undefined || values === '') {
        return;
    }

    if (typeof values === 'string') {
        return toPredicateExpression(key, values, FilterOperation.Contains, FilterCollation.Ignorecase);
    }

    if (typeof values === 'number') {
        return toPredicateExpression(key, values);
    }

    if (Array.isArray(values)) {
        if (!values.length || (values.length === 1 && values[0] === null)) {
            return undefined;
        }

        if (values.length === 1) {
            return toPredicateExpression(
                key,
                values[0],
            );
        }

        if (values.length > 1) {
            return toGroupingExpression(
                values.map(value => toPredicateExpression(key, value)),
            );
        }
    }
}

